import { CarModel } from "@/api/generated/BMWInterfaces"
import { Desktop, Mobile } from "@/lib/common/MediaQueries"
import { modelClick, showMoreCarsClick } from "@/lib/gtm"
import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { useState } from "react"
import CarsCard from "../shared/CarsCard"

const StyledLayout = styled.div`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  width: 100%;
  gap: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    align-items: center;
    gap: 40px;
  }
`

const CarsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: repeat(3, 1fr);
    padding: 0 76px;
    max-width: 1200px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    grid-template-columns: repeat(3, 1fr);
    padding: 0 106px;
    max-width: 1280px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;

  ${(props) => props.theme.breakpoints.up("md")} {
    text-align: center;
    align-items: center;
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    padding: 56px 0 24px 0;
    align-items: center;
    text-align: center;
    gap: 16px;
  }
`

const ButtonBox = styled.div`
  display: flex;
  justify-content: center;
`

const StyledButton = styled(Button)`
  color: black;
  text-decoration: underline;
  :hover {
    background-color: transparent;
  }
`

export const isModelActive = (model: CarModel): boolean => {
  const now = new Date().toLocaleString("en-US", { timeZone: "Asia/Jerusalem" })
  const nowDate = new Date(now)
  const dueDate = new Date(model.dueDate)
  const startDateObj = new Date(model.startDate)

  return model.isActive && dueDate > nowDate && startDateObj <= nowDate
}

export default function PremiumDeals({ data }: { data: CarModel[] }): React.ReactElement {
  const [showAll, setShowAll] = useState(false)
  const allowedCars = data
    .filter((el) => {
      return isModelActive(el)
    })
    .slice(0, 15)

  const displayedCars = showAll ? allowedCars : allowedCars.slice(0, 6)
  const handleShowAll = (): void => setShowAll(true)
  return (
    <StyledLayout>
      <TextBox>
        <Mobile>
          <Typography variant="h3">
            הזדמנויות מיוחדות לרכבים חדשים ורכבי 0 ק&quot;מ לזמן מוגבל
          </Typography>
        </Mobile>
        <Mobile centerHorizontally>
          <Typography variant="body1">מבית דלק מוטורס</Typography>
        </Mobile>
        <Desktop>
          <Typography variant="h1">
            הזדמנויות מיוחדות לרכבים חדשים ורכבי 0 ק&quot;מ לזמן מוגבל
          </Typography>
        </Desktop>
        <Desktop>
          <Typography variant="h3">מבית דלק מוטורס</Typography>
        </Desktop>
      </TextBox>
      <CarsGrid>
        {displayedCars.map((el, i) => (
          <CarsCard
            data={el}
            key={i}
            onClick={() => {
              modelClick(el.name)
            }}
          />
        ))}
      </CarsGrid>

      {!showAll && allowedCars.length > 6 ? (
        <ButtonBox>
          <StyledButton
            variant="text"
            onClick={() => {
              showMoreCarsClick()
              handleShowAll()
            }}
            disableRipple
          >
            הצג לי עוד רכבים
          </StyledButton>
        </ButtonBox>
      ) : null}
    </StyledLayout>
  )
}
